import React, {Component} from 'react';
import * as d3 from 'd3';

class Choropleth extends Component {
    constructor(props) {
        super(props);
        this.createGraph = this.createGraph.bind(this);
        this.removeGraph = this.removeGraph.bind(this);
    }

    componentDidMount() {
        if (this.props.country_data.length !== 0 && this.props.country_data !== undefined && this.props.country_data !== null && Object.keys(this.props.data).length !== 0 && this.props.data.constructor === Object && this.props.data !== undefined && this.props.data !== null) {
            this.createGraph();
        }
    }

    componentDidUpdate() {
        if (this.props.country_data.length !== 0 && this.props.country_data !== undefined && this.props.country_data !== null && Object.keys(this.props.data).length !== 0 && this.props.data.constructor === Object  && this.props.data !== undefined && this.props.data !== null) {
            this.removeGraph();
            this.createGraph();
        }
    }

    createGraph() {
        const data = this.props.data;
        const svg = d3.select("." + this.props.name + " svg"),
        margin = {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
        },
        width = this.props.width - margin.left - margin.right,
        height = this.props.height - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        svg
        .attr("width", '100%')
        .attr("height", '100%')
        .attr('viewBox','0 0 ' + this.props.width +' '+ this.props.height)
        .attr('preserveAspectRatio','xMinYMin');
        
        const projection = d3.geoMercator()
        .scale(100)
        .translate( [width / 2, height / 1.5]);

        const path = d3.geoPath().projection(projection);

        const colorMax = d3.max(this.props.country_data, function(d){ return d.respondents; });
        const colorScale = d3.scaleLinear()
        .domain([0, colorMax])
        .range(['#ffffff', '#912424'])
        .interpolate(d3.interpolateHcl); //interpolateHsl interpolateHcl interpolateRgb

        const props = this.props;
        g.selectAll("path")
            .data(data.features)
            .enter()
            .append("path")
            .attr("d", path)
            .style("fill", function(d,i) {
                let n = 0;
                for (let i = 0; i < props.country_data.length; i++) {
                    if (props.country_data[i].country === d.properties.name) {
                        n = props.country_data[i].respondents;
                    }
                }
                return colorScale(n); 
            })
            .style("stroke","grey")
            .style("stroke-width",0.3)
            .on('mouseover',function(d){      
                d3.select(this)
                  .style("cursor", "pointer")
                  .style("stroke","black")
                  .style("stroke-width",1);
              })
              .on('mouseout', function(d){
                d3.select(this)
                  .style("stroke","grey")
                  .style("stroke-width",0.3);
              })
              .on('click', function(d,i) {
                 props.selectCountry(d.properties.name);
              });
    }

    removeGraph() {
        var svg = d3.select("." + this.props.name + " svg"),
        g = svg.select("g");    
        g.remove();
    }

    render() {
        return (
            <div className = {this.props.name}>
                <svg width={this.props.width} height={this.props.height}/>
            </div>
        );
    }

}

export default Choropleth


// WEBPACK FOOTER //
// ./src/components/choropleth.js